/**
 * Vuely Global Components
 */
import GGBreadcrumbs from 'Components/Global/GGBreadcrumbs'
import GGCardTitle from 'Components/Global/GGCardTitle'
import GGLoading from 'Components/Global/GGLoading'
// import GGLazy from 'Components/Global/GGLazy'
import GGToolbar from 'Components/Global/GGToolbar'
import GGModal from 'Components/Global/GGModal'
import GGError from 'Components/Global/GGError'
import GGDateTimePicker from 'Components/Global/DateTimePicker.vue'
import GGCard from 'Components/Global/Card/GGCard'
import GGCardHeader from 'Components/Global/Card/GGCardHeader'
import GGCardText from 'Components/Global/Card/GGCardText'
import GGTextField from 'Components/Global/Inputs/GGTextField'
import GGSelect from 'Components/Global/Inputs/GGSelect'
import GGInputLabel from 'Components/Global/Inputs/GGInputLabel'
import GGBtn from 'Components/Global/GGBtn'

const GlobalComponents = {
  install (Vue) {
    // Vue.component('appCard', AppCard)
    // Vue.component('deleteConfirmationDialog', DeleteConfirmationDialog)
    // Vue.component('appSectionLoader', AppSectionLoader)
    Vue.component('GgBreadcrumbs', GGBreadcrumbs)
    Vue.component('GgCardTitle', GGCardTitle)
    Vue.component('GgLoading', GGLoading)
    // Vue.component('GgLazy', GGLazy)
    Vue.component('GgToolbar', GGToolbar)
    Vue.component('GgModal', GGModal)
    Vue.component('GgError', GGError)
    Vue.component('GGDateTimePicker', GGDateTimePicker)
    // card
    Vue.component('GgCard', GGCard)
    Vue.component('GgCardHeader', GGCardHeader)
    Vue.component('GgCardText', GGCardText)
    // inputs
    Vue.component('GgTextField', GGTextField)
    Vue.component('GgSelect', GGSelect)
    Vue.component('GgInputLabel', GGInputLabel)
    // buttons
    Vue.component('GgBtn', GGBtn)
  }
}

export default GlobalComponents
